export default "/_next/static/images/header-bg-c66fd380961c0ebd01d61db6c31ec639.png";